"use strict";
var _a;
exports.__esModule = true;
exports.SearchIcon = exports.ALT_KEY = void 0;
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var search_results_1 = require("@hiyllo/omni-common/src/types/search/search-results");
var react_native_1 = require("react-native");
exports.ALT_KEY = react_native_1.Platform.OS !== 'web'
    ? ''
    :
        window.navigator.userAgent.includes('Mac')
            ? '⌥'
            : 'Alt';
exports.SearchIcon = (_a = {},
    _a[search_results_1.SearchIconEnum.calendar] = pro_light_svg_icons_1.faCalendar,
    _a[search_results_1.SearchIconEnum.tasks] = pro_light_svg_icons_1.faListCheck,
    _a[search_results_1.SearchIconEnum.chat] = pro_light_svg_icons_1.faComments,
    _a);
